import React, { useState, useEffect } from "react";
import { useAuth } from "../../hooks/GlobalProvider";
import { FaExpeditedssl, FaMoneyCheck, FaTeamspeak } from "react-icons/fa";
import {
  Payment_Gateway_Create_order,
  Payment_Gateway_Save_Order,
  Payment_Gateway_Save_payment,
  Get_Razorpay_Config,
} from "../../hooks/APIHooks";
import { razorpay } from "../../assets/data/Imagedata";
import { useNavigate } from "react-router-dom";

const Checkout = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [fullName, setFullName] = useState(user.name || "");
  const [userData, setUserData] = useState({
    emailaddress: user.emailaddress || "",
    phonenumber: user.phonenumber || "",
    address: user.address || "",
  });
  const [cart, setCart] = useState(
    JSON.parse(localStorage.getItem("cart")) || []
  );
  const [address, setAddress] = useState({
    street: "",
    city: "",
    state: "",
    pincode: "",
    country: "India",
  });
  const [isTermsAccepted, setIsTermsAccepted] = useState(true);
  const [paymentMethod, setPaymentMethod] = useState("razorpay");
  const [currencyData, setCurrencyData] = useState(null);
  const [isDiscountApplied, setIsDiscountApplied] = useState(false);
  const [razorpayConfig, setRazorpayConfig] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (user.name) {
      setUserData({
        emailaddress: user.emailaddress,
        phonenumber: user.phonenumber || "",
        address: user.address || "",
      });
    }
  }, [user]);

  // Fetch Razorpay configuration
  useEffect(() => {
    const fetchRazorpayConfig = async () => {
      try {
        const response = await fetch(Get_Razorpay_Config);
        const config = await response.json();
        if (config.keyId) {
          setRazorpayConfig(config);
        } else {
          setRazorpayConfig({ keyId: "rzp_live_Tp5xLQ45PCoKUz" });
        }
      } catch (error) {
        console.error("Failed to fetch Razorpay config:", error);
        setRazorpayConfig({ keyId: "rzp_live_Tp5xLQ45PCoKUz" });
      }
    };

    fetchRazorpayConfig();
  }, []);

  // Function to get proper image URL - Consistent with other components
  const getImageUrl = (imagePath) => {
    if (!imagePath)
      return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiBmaWxsPSIjZjNmNGY2Ii8+PHRleHQgeD0iNDgiIHk9IjQ4IiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTIiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGRvbWluYW50LWJhc2VsaW5lPSJtaWRkbGUiIGZpbGw9IiM5YTliYWIiPk5vIEltYWdlPC90ZXh0Pjwvc3ZnPg==";

    // If it's already a full URL, return as is
    if (imagePath.startsWith("http")) return imagePath;

    // If it's a relative path, construct full URL
    if (imagePath.startsWith("/")) {
      return `${window.location.origin}${imagePath}`;
    }

    // For other cases, try to construct URL
    const cleanPath = imagePath.replace(/^(\.?\/?)?/, "");

    // Handle different environments
    let baseUrl;
    const { hostname, port, protocol } = window.location;

    if (hostname === "localhost" && port === "3000") {
      // React dev server on port 3000, APIs on port 80
      baseUrl = `${protocol}//${hostname}`;
    } else if (hostname === "localhost" && !port) {
      // React build served from same domain as APIs
      baseUrl = window.location.origin;
    } else {
      // Production environment
      baseUrl = window.location.origin;
    }

    return `${baseUrl}/apis/${cleanPath}`;
  };

  // Handle image loading errors
  const handleImageError = (e) => {
    console.warn("Image failed to load:", e.target.src);
    e.target.src =
      "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiBmaWxsPSIjZjNmNGY2Ii8+PHRleHQgeD0iNDgiIHk9IjQ4IiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTIiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGRvbWluYW50LWJhc2VsaW5lPSJtaWRkbGUiIGZpbGw9IiM5YTliYWIiPk5vIEltYWdlPC90ZXh0Pjwvc3ZnPg==";
    e.target.alt = "Image not available";
    e.target.className = e.target.className + " bg-gray-200";
  };

  const totalCartValue = cart.reduce(
    (total, product) => total + product.price * product.quantity,
    0
  );
  const shippingCharge = 50;

  const maxDiscount = cart.reduce((totalDiscount, item) => {
    const itemDiscount =
      item.companyName === "Akhil" || item.companyName === "WELLGRO"
        ? item.price * item.quantity * 0.4
        : item.price * item.quantity * 0.5;
    return totalDiscount + itemDiscount;
  }, 0);

  const availableDiscount = currencyData ? currencyData.digital_currency : 0;
  const finalDiscount = Math.min(maxDiscount, availableDiscount);
  const roundedDiscount = Math.floor(finalDiscount);

  const discountedSubtotal =
    totalCartValue - (isDiscountApplied ? roundedDiscount : 0);
  const totalAmount = discountedSubtotal + shippingCharge;

  const handleRemoveItem = (productId) => {
    const updatedCart = cart.filter((item) => item.product_id !== productId);
    setCart(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  const handlePayment = async () => {
    if (paymentMethod === "razorpay") {
      await handleRazorpayPayment();
    }
  };

  const handleRazorpayPayment = async () => {
    if (!razorpayConfig || !razorpayConfig.keyId) {
      alert(
        "Payment gateway is not configured properly. Please try again later."
      );
      return;
    }

    setIsProcessing(true);

    const vendorUserIds = [
      ...new Set(cart.map((item) => item.vendor_user_id)),
    ].join(",");

   const orderDetails = {
  user_id: user.user_id,
  vendor_user_id: vendorUserIds,
  name: fullName,
  email: userData.emailaddress,
  phone: userData.phonenumber,
  address: handleShippingAddress(),
  cart: [...cart],
  subtotal: totalCartValue,
  amount: totalAmount,
  shippingcharge: shippingCharge,
  discount: isDiscountApplied ? roundedDiscount : 0, // Make sure this is included
};

    try {
      console.log("Saving order details...");
      // In your handleRazorpayPayment function, after saving order:
      const saveOrderResponse = await fetch(Payment_Gateway_Save_Order, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(orderDetails),
      });

      const saveOrderResult = await saveOrderResponse.json();

      if (!saveOrderResult.success) {
        if (saveOrderResult.errors) {
          // Handle stock validation errors
          alert("Stock issues: " + saveOrderResult.errors.join(", "));
          // You might want to update the cart here
        } else {
          alert(
            "Failed to save order: " +
              (saveOrderResult.error || "Unknown error")
          );
        }
        setIsProcessing(false);
        return;
      }

      const razorpayOrder = {
        amount: totalAmount * 100,
        currency: "INR",
        receipt: `order_rcptid_${saveOrderResult.order_id}`,
      };

      console.log("Creating Razorpay order...");
      const razorpayResponse = await fetch(Payment_Gateway_Create_order, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(razorpayOrder),
      });

      const razorpayOrderData = await razorpayResponse.json();
      console.log("Razorpay order response:", razorpayOrderData);

      if (!razorpayOrderData.id) {
        alert(
          "Error creating Razorpay order: " +
            (razorpayOrderData.error || "Unknown error")
        );
        setIsProcessing(false);
        return;
      }

      const options = {
        key: razorpayConfig.keyId,
        amount: razorpayOrder.amount,
        currency: "INR",
        name: "Ecommerce",
        description: "Purchase Description",
        order_id: razorpayOrderData.id,
        handler: async function (response) {
          console.log("Razorpay payment successful:", response);

          const paymentData = {
            order_id: saveOrderResult.order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            discount_used: isDiscountApplied ? roundedDiscount : 0,
            user_id: user.user_id,
          };

          try {
            console.log("Saving payment details...");
            const paymentSaveResponse = await fetch(
              Payment_Gateway_Save_payment,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(paymentData),
              }
            );

            // Get the response text first to handle potential non-JSON responses
            const responseText = await paymentSaveResponse.text();
            console.log("Payment save raw response:", responseText);

            let paymentSaveResult;
            try {
              paymentSaveResult = JSON.parse(responseText);
            } catch (parseError) {
              console.error(
                "Failed to parse payment response as JSON:",
                parseError
              );
              // If it's not JSON, check if it contains success message
              if (
                responseText.includes("success") ||
                responseText.includes("Success")
              ) {
                paymentSaveResult = {
                  success: true,
                  message: "Payment processed successfully",
                };
              } else {
                throw new Error("Invalid response from payment server");
              }
            }

            console.log("Payment save parsed response:", paymentSaveResult);

            // Check for success in various possible formats
            const isSuccess =
              paymentSaveResult.success === true ||
              paymentSaveResult.status === "success" ||
              (typeof paymentSaveResult === "string" &&
                paymentSaveResult.includes("success"));

            if (isSuccess) {
              // Clear cart after successful payment
              localStorage.removeItem("cart");
              setCart([]);

              console.log("Payment successful, navigating to success page...");
              // Store order data in localStorage as backup
              localStorage.setItem(
                "lastSuccessfulOrder",
                JSON.stringify({
                  orderId: saveOrderResult.order_id,
                  totalAmount: totalAmount,
                })
              );

              navigate("/Store/checkout/paymentsuccess", {
                state: {
                  orderId: saveOrderResult.order_id,
                  totalAmount: totalAmount,
                },
              });
            } else {
              const errorMessage =
                paymentSaveResult.message ||
                paymentSaveResult.error ||
                "Payment verification failed";
              console.error("Payment verification failed:", errorMessage);
              alert(`Payment verification failed: ${errorMessage}`);
            }
          } catch (error) {
            console.error("Error saving payment:", error);

            // Even if there's an error saving payment record, if Razorpay says it's successful
            // and the payment is in database, we should still redirect to success page
            console.log(
              "Payment might still be successful. Checking if we should redirect..."
            );

            // Clear cart
            localStorage.removeItem("cart");
            setCart([]);

            // Store order data in localStorage as backup
            localStorage.setItem(
              "lastSuccessfulOrder",
              JSON.stringify({
                orderId: saveOrderResult.order_id,
                totalAmount: totalAmount,
              })
            );

            // Redirect to success page with warning
            navigate("/Store/checkout/paymentsuccess", {
              state: {
                orderId: saveOrderResult.order_id,
                totalAmount: totalAmount,
                warning:
                  "Payment was successful but there was an issue saving the record. Please contact support with your order ID.",
              },
            });
          }
        },
        prefill: {
          name: fullName,
          email: userData.emailaddress,
          contact: userData.phonenumber,
        },
        theme: {
          color: "#3399cc",
        },
        modal: {
          ondismiss: function () {
            console.log("Payment modal dismissed");
            setIsProcessing(false);
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", function (response) {
        console.error("Payment failed:", response.error);
        alert(
          `Payment failed: ${response.error.description || "Unknown error"}`
        );
        setIsProcessing(false);
      });

      rzp.open();
    } catch (error) {
      console.error("Error during payment process:", error);
      alert("An error occurred during payment. Please try again.");
      setIsProcessing(false);
    }
  };

  const handleShippingAddress = () => {
    const { street, city, state, pincode, country } = address;
    return `${street}, ${city}, ${state}, ${pincode}, ${country}`;
  };

  const isFormValid = () => {
    const { street, city, state, pincode, country } = address;
    return (
      fullName &&
      userData.emailaddress &&
      userData.phonenumber &&
      street &&
      city &&
      state &&
      pincode &&
      country &&
      isTermsAccepted &&
      totalCartValue > 0
    );
  };

  // Debug: Log image URLs to console
  useEffect(() => {
    if (cart.length > 0) {
      console.log("Checkout cart items with image URLs:");
      cart.forEach((item, index) => {
        console.log(`Item ${index + 1}:`, {
          name: item.product_name,
          originalImage: item.product_image,
          processedUrl: getImageUrl(item.product_image),
        });
      });
    }
  }, [cart]);

  return (
    <section className="overflow-hidden sm:px-10 px-4 ">
      <section className="mx-auto w-full grid grid-cols-1 gap-1 md:grid-cols-2 pt-10">
        <div>
          <p className="text-[28px] font-bold">Complete your order</p>
          <p className="mt-2 text-gray-600">
            Please fill in your details below
          </p>
        </div>
        <div>
          <p className="mt-2 flex items-center gap-2 text-gray-500">
            <FaExpeditedssl className="text-[20px] text-black" />
            SSL secured checkout
          </p>
          <p className="mt-2 flex items-center gap-2 text-gray-500">
            <FaTeamspeak className="text-[20px] text-black" />
            24/7 support available
          </p>
          <p className="mt-2 flex items-center gap-2 text-gray-500">
            <FaMoneyCheck className="text-[20px] text-black" />
            Payment option
          </p>
        </div>
      </section>

      <div className="py-16 mx-auto w-full grid grid-cols-1 gap-1 md:grid-cols-2">
        {/* Left side: Customer Details */}
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-6">Your Details</h2>
          <div className="mb-6">
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              placeholder="Full Name"
              className="border-b border-gray-300 py-2 text-base text-black mt-4 w-full px-2 rounded-md"
            />
            {["street", "city", "state", "pincode", "country"].map((field) => (
              <input
                key={field}
                type="text"
                value={address[field]}
                onChange={(e) =>
                  setAddress({ ...address, [field]: e.target.value })
                }
                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                className="border-b border-gray-300 py-2 text-base text-black mt-4 w-full"
              />
            ))}
            <input
              type="email"
              value={userData.emailaddress}
              onChange={(e) =>
                setUserData({ ...userData, emailaddress: e.target.value })
              }
              placeholder="Email"
              className="border-b border-gray-300 py-2 text-base text-black mt-4 w-full bg-gray-200 px-2 rounded-md"
              readOnly
            />
            <input
              type="text"
              value={userData.phonenumber}
              onChange={(e) =>
                setUserData({ ...userData, phonenumber: e.target.value })
              }
              placeholder="Phone Number"
              className="border-b border-gray-300 py-2 text-base text-black mt-4 w-full bg-gray-200 px-2 rounded-md"
              readOnly
            />
            <div className="mt-4">
              <input
                type="checkbox"
                checked={isTermsAccepted}
                onChange={() => setIsTermsAccepted(!isTermsAccepted)}
              />
              <span className="ml-2">I agree to the Terms & Conditions</span>
            </div>
          </div>
        </div>

        {/* Right side: Cart Summary */}
        <div className="bg-white p-4 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-6">Order Summary</h2>
          <div className="bg-white shadow-md rounded-lg p-4">
            <table className="min-w-full table-auto border-collapse">
              <thead>
                <tr className="bg-primary">
                  <th className="py-3 px-4 text-left text-black">Product</th>
                  <th className="py-3 px-4 text-left text-black">Price</th>
                </tr>
              </thead>
              <tbody>
                {cart.map((item) => (
                  <tr key={item.product_id} className="border-b">
                    <td className="flex items-center py-3 px-4">
                      <div className="flex-shrink-0 w-24 h-24 mr-4">
                        <img
                          src={getImageUrl(item.product_image)}
                          alt={item.product_name || "Product image"}
                          className="object-cover w-full h-full rounded"
                          onError={handleImageError}
                          loading="lazy"
                        />
                      </div>
                      <div>
                        {item.product_type !== "single" && (
                          <span className="block text-sm text-gray-700">
                            {item.variant}
                          </span>
                        )}
                        <span className="font-medium">{item.product_name}</span>
                      </div>
                    </td>
                    <td className="text-right py-3 px-4">
                      <span className="font-medium">
                        ₹{item.price} x {item.quantity}
                      </span>
                      <button
                        onClick={() => handleRemoveItem(item.product_id)}
                        className="text-red-500 ml-2 hover:underline"
                      >
                        x
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="mt-4">
              <p className="text-gray-600">
                Sub Total: <strong>₹{totalCartValue}</strong>
              </p>
              {isDiscountApplied && (
                <p className="text-gray-600">
                  Discount Applied: <strong>₹{roundedDiscount}</strong>
                </p>
              )}
              <p className="text-gray-600">
                Shipping Charge: <strong>₹{shippingCharge}</strong>
              </p>
              <p className="text-gray-600">
                <strong>Total: ₹{totalAmount}</strong>
              </p>
            </div>
          </div>

          {/* Payment Method Selection */}
          <div className="mt-4">
            <div className="flex items-center justify-center">
              <div className="w-full max-w-lg px-10 py-8 mx-auto">
                <div className="max-w-md mx-auto space-y-6">
                  <div className="space-y-4">
                    <p className="text-sm font-medium text-center text-neutral-500">
                      Payment Option
                    </p>
                    <div className="relative">
                      <input
                        type="radio"
                        name="payment-options"
                        id="razorpay-checkbox"
                        value="razorpay"
                        checked={paymentMethod === "razorpay"}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        className="hidden peer"
                      />
                      <label
                        htmlFor="razorpay-checkbox"
                        className="inline-flex items-center justify-between w-full p-5 bg-white border-2 rounded-lg cursor-pointer group border-neutral-200/70 text-neutral-600 peer-checked:border-blue-400 peer-checked:text-neutral-900 peer-checked:bg-blue-200/50 hover:text-neutral-900 hover:border-neutral-300"
                      >
                        <div className="flex items-center space-x-5">
                          <div className="flex flex-col justify-center">
                            <img
                              src={razorpay}
                              alt="Razorpay"
                              className="w-auto h-8"
                              onError={handleImageError}
                            />
                            <div className="w-full text-sm opacity-60">
                              Pay securely with Razorpay
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={handlePayment}
            disabled={!isFormValid() || !razorpayConfig || isProcessing}
            className={`bg-black text-white px-6 py-3 rounded-lg mt-4 w-full ${
              isFormValid() && razorpayConfig && !isProcessing
                ? "bg-black hover:bg-gray-800"
                : "bg-gray-300 cursor-not-allowed"
            }`}
          >
            {isProcessing
              ? "Processing..."
              : !razorpayConfig
              ? "Loading..."
              : "Pay Now"}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Checkout;
